import { EMPTY_ARRAY } from 'data/global';
import { createContext } from 'react';
import {
  DataRoomNdaSigner,
  DataRoomNdaSigning,
} from 'router/subrouters/DataRoom/models/DataRoomNDA';
import utils from 'utils';

type DataRoomNdaTableContextProps = {
  selected: DataRoomNdaSigner[];
  isAllSelected: boolean;
  openNdaDrawer: (
    signer: DataRoomNdaSigner,
    signing: DataRoomNdaSigning,
  ) => void;
  openNdaModal: (signer: DataRoomNdaSigner) => void;
  selectAll: () => void;
  removeAll: () => void;
  updateSelected: (signer: DataRoomNdaSigner) => void;
  refetch: () => void;
};

export default createContext<Partial<DataRoomNdaTableContextProps>>({
  selected: EMPTY_ARRAY,
  isAllSelected: false,
  openNdaDrawer: utils.noop,
  openNdaModal: utils.noop,
  selectAll: utils.noop,
  removeAll: utils.noop,
  updateSelected: utils.noop,
  refetch: utils.noop,
});
